import { useTranslation } from 'next-i18next'
import React from 'react'

import { skillLabels } from '../../../functions/skillLabels'
import { useFeedbackStore } from '../../../functions/store'
import RatingLabel from '../ratingLabel'
import { AreaTitle } from './areaTitle'

const GameSkills = ({ fighter, index }) => {
  const store = useFeedbackStore((state) => state)
  const { addPoint, removePoint } = store.feedbackActions
  const pointsLeft = store.ratings[index].pointsLeft

  const { t } = useTranslation('avaliacao360')

  // Getting the GameSkills keys and current points for the current fighter
  const gameSkillsList = store.ratings[index].gameSkills

  return (
    <div className="w-full mb-8 group bg-white p-3 md:p-4 rounded-xl">
      <AreaTitle title={t('gameSkills.title')} />
      <p className="-mt-3 text-sm sm:mb-3">
        <em>
          {t('gameSkills.labelCharacteristics')}{' '}
          <strong
            className={`inline-block h-6 w-6 pt-1 text-white rounded-full text-center bg-black/50`}
          >
            {pointsLeft}
          </strong>
        </em>
      </p>
      <div className="grid grid-cols-2 w-full lg:grid-cols-3 mt-2">
        {Object.entries(gameSkillsList).map(([skill, points]) => (
          <div
            key={skill}
            className="text-center border-b-1 border-slate-200 px-2"
          >
            <RatingLabel
              className="text-red-900"
              text={t(`gameSkills.${skillLabels(skill)}`)}
            />
            <div className="flex flex-row justify-center my-2 mb-3">
              <button
                className="bg-red-400 text-white p-0 rounded-full h-6 w-6 self-center"
                onClick={() => removePoint(fighter, skill)}
              >
                -
              </button>
              <p className="px-3 self-center">{points}</p>
              <button
                className="bg-red-400 text-white p-0 rounded-full h-6 w-6 self-center"
                onClick={() => addPoint(fighter, skill)}
              >
                +
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
export default GameSkills
